// extracted by mini-css-extract-plugin
export default {"CardWrapper":"CardWrapper__2dhpj","bg":"bg__3Ti1P","Card":"Card__1C5ip","logo":"logo__2RPBM","Title":"Title__3tohZ","Description":"Description__3dvvo","Button":"Button__1Io82"};